/**
 * Copyright (c) 2025 Répét Contributors
 * Licensed under the MIT License
 * See LICENSE file in the project root for full license text
 */

/**
 * Configuration de l'environnement
 */

// Environnement (prod ou dev)
export const IS_DEV = import.meta.env.MODE === 'development' || import.meta.env.VITE_ENV === 'dev'

// Nom de l'application selon l'environnement
export const APP_NAME = IS_DEV
  ? 'dev.Répét'
  : 'Répét'

// Nom complet de l'application
export const APP_FULL_NAME = IS_DEV
  ? 'dev.Répét - Répétition Théâtre'
  : 'Répét - Répétition Théâtre'

// Couleur de thème selon l'environnement
export const THEME_COLOR = IS_DEV ? '#f59e0b' : '#2563eb' // Orange pour dev, bleu pour prod

// Label de l'environnement pour affichage
export const ENV_LABEL = IS_DEV ? 'DEV' : ''

// Badge de l'environnement
export const ENV_BADGE = IS_DEV ? '🔧 DEV' : ''
